// extracted by mini-css-extract-plugin
export default {"title":"_4f08b4a372","bld":"_28361cd27c"};